module.exports = __webpack_public_path__ + "img/kubeapps.501add5a.png";